/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable prefer-const */
import React, { useEffect, useRef, useState } from "react";
import "../App.css";
import { MdOutlineContentCopy as PasteBtn } from "react-icons/md";
import { toast } from "react-toastify";
import Select from "./Select/Select";
import CopyRight from "./CopyRight";
import * as XLSX from "xlsx";
import { FaFilter } from "react-icons/fa6";
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) {
  const renderPaginationButtons = () => {
    const buttons: any[] = [];
    let startPage: number, endPage: number;
    if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 2 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          className={`px-4 py-1 ${i === currentPage
            ? "bg-[#1B163B] text-white text-sm"
            : " text-[#1B163B] text-sm font-normal"
            }`}
          onClick={() => onPageChange(i)}
        >
          {i}
        </button>,
      );
    }

    if (totalPages > 5) {
      if (currentPage + 1 > 5) {
        buttons.unshift(<span key="ellipsis2">...</span>);
      }
      if (currentPage + 1 > 5) {
        buttons.unshift(
          <button
            className="px-3 py-1 mx-1 text-[#1B163B] text-sm font-normal"
            onClick={() => onPageChange(1)}
          >
            {1}
          </button>,
        );
      }
      if (currentPage > 3) {
        buttons.unshift(
          <button
            key="prev"
            className="px-3 py-1 mx-1 text-[#1B163B] text-sm font-normal"
            onClick={() => onPageChange(currentPage - 1)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 19.5 8.25 12l7.5-7.5"
              />
            </svg>
          </button>,
        );
      }
      if (currentPage + 3 < totalPages) {
        buttons.splice(buttons.length, 0, <span key="ellipsis1">...</span>);
      }

      if (currentPage + 3 < totalPages) {
        buttons.push(
          <button
            className="px-3 py-1 mx-1 text-[#1B163B] text-sm font-normal"
            onClick={() => onPageChange(totalPages)}
          >
            {totalPages}
          </button>,
        );
      }

      if (currentPage + 2 < totalPages) {
        buttons.push(
          <button
            key="next"
            className="px-3 py-1 mx-1 text-[#1B163B] text-sm font-normal"
            onClick={() => onPageChange(currentPage + 1)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </button>,
        );
      }
    }

    return buttons;
  };

  return <div className="flex items-center">{renderPaginationButtons()}</div>;
}

export function RowsPerPageSelect({
  setItemsPerRow,
  itemsPerRow,
  className,
}: any) {
  return (
    <div
      className={
        "flex gap-x-2 text-xs items-center px-4 mt-2 py-0 " +
        (className && className ? className : " justify-end")
      }
    >
      <p className=" shrink-0">Rows per page:</p>
      <Select
        selected={itemsPerRow}
        setSelected={setItemsPerRow}
        options={[10, 50, 150, 500].map((num) => {
          return { name: num };
        })}
      />
    </div>
  );
}

export const Table = ({
  data,
  heading,
  footer,
  description,
  searchBox,
  csv_name,
  srNo,
  copyContent,
  pagination,
  filter,
  perPage,
  exportBtn,
  boxPadding,
  bgColor,
  minHeight,
  copyRight = true,
  loading = false,
  isCustomFilter = false,
  currentPage: externalCurrentPage,
  headerRowClassName = "",
  headerCellClassName = "",
  rowClassName = "",
  cellWrapperClassName = "",
  tableClassName = "",
  tableWrapperClassName = "grid grid-cols-1 overflow-x-auto p-4",
}: any) => {

  const [csv_link, set_csv_link] = useState<string>("");
  const refs = useRef<any[]>([]);
  const rawColumn = srNo ? ["Sr.No", ...data[0]] : data[0];
  const getColumnKey = (col: any) =>
    typeof col === "string" ? col : col?.key || String(col?.label || "");
  const getColumnLabel = (col: any) =>
    typeof col === "string" ? col : col?.label || col?.key || "";
  const column: string[] = rawColumn.map(getColumnKey);
  const columnLabels = rawColumn.map(getColumnLabel);
  const [currentPage, setCurrentPage] = useState<number>(
    externalCurrentPage ?? 1
  );
  const [itemsPerRow, setItemsPerRow] = useState<{ name: number }>({
    name: 10,
  });

  // NEW STATES for modal
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedColumns, setSelectedColumns] = useState<string[]>(
    column.filter((c) => c !== "Sr.No"), // exclude Sr.No from modal selection
  );

  const [tempSelectedColumns, setTempSelectedColumns] = useState<string[]>(
    column.filter((c) => c !== "Sr.No"),
  );
  const columnKey = column.join("|");

  useEffect(() => {
    const visibleColumns = column.filter((c) => c !== "Sr.No");
    setSelectedColumns(visibleColumns);
    setTempSelectedColumns(visibleColumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnKey]);

  const items = data?.slice(1);
  const totalPages = Math.ceil(items.length / itemsPerRow?.name);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const indexOfLastItem = currentPage * itemsPerRow?.name;
  const indexOfFirstItem = indexOfLastItem - itemsPerRow?.name;
  const currentItems = items.slice(indexOfFirstItem, indexOfLastItem);
  const currentItemsArray = pagination ? currentItems : data?.slice(1);
  useEffect(() => {
    setCurrentPage(1);
  }, [filter, itemsPerRow]);

  useEffect(() => {
    if (externalCurrentPage !== undefined) {
      setCurrentPage(externalCurrentPage);
    }
  }, [externalCurrentPage]);

  // helper: copy text
  const handleCopyContent = (content: any) => {
    const copy_content =
      typeof content?.props?.children === "string"
        ? content?.props?.children
        : content?.props?.children?.props?.children;

    navigator.clipboard
      .writeText(copy_content ? copy_content : content)
      .then(() => toast.success("Copied to clipboard"))
      .catch(() => toast.error("Error while copying"));
  };

  // === Export logic updated for Sr.No reset ===
  const generateExcel = () => {
    if (!refs?.current || !column?.length) return;

    const insertLineBreaks = (str: string) => {
      if (!str) return str;
      const maxLen = 30;
      if (str.length <= maxLen) return str;
      let res = "";
      for (let i = 0; i < str.length; i += maxLen) {
        res += str.substr(i, maxLen) + "\n";
      }
      return res;
    };

    function removeButtons(node: HTMLElement) {
      const buttons = node.querySelectorAll("button");
      buttons.forEach((btn) => btn.remove());
    }

    const allData = [
      columnLabels.map((label: any, index: number) =>
        typeof label === "string" ? label : column[index],
      ),
      ...refs.current.map((r) => {
        if (!r) return column.map(() => "");
        return Array.from(r.children).map((c: any) => {
          const clone = c.cloneNode(true) as HTMLElement;
          removeButtons(clone);
          return insertLineBreaks(clone.innerText.replace("\u20b9", ""));
        });
      }),
    ];

    // Filter columns based on user selection (excluding Sr.No)
    const selectedCols = ["Sr.No", ...selectedColumns];
    const selectedIndices = column
      .map((col, i) => (selectedCols.includes(col) ? i : -1))
      .filter((i) => i !== -1);

    const filteredData = allData.map((row, rowIndex) =>
      selectedIndices.map((i, idx) =>
        i === 0 ? (rowIndex === 0 ? "Sr.No" : rowIndex) : row[i],
      ),
    );

    const getMaxColumnWidths = (data: any[]) => {
      const colCount = data[0].length;
      const maxWidths = Array(colCount).fill(10);
      for (let c = 0; c < colCount; c++) {
        for (let r = 0; r < data.length; r++) {
          const val = data[r][c];
          const len = val ? val.toString().length : 0;
          if (len > maxWidths[c]) maxWidths[c] = len;
        }
      }
      return maxWidths;
    };

    const colWidths = getMaxColumnWidths(filteredData).map((w) => ({
      wch: w + 5,
    }));
    const ws = XLSX.utils.aoa_to_sheet(filteredData);
    ws["!cols"] = colWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    set_csv_link(url);
  };

  useEffect(() => {
    generateExcel();
    return () => {
      if (csv_link) URL.revokeObjectURL(csv_link);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, currentPage, itemsPerRow?.name, selectedColumns]);

  const toggleTempSelectAll = () => {
    const colsWithoutSrNo = column.filter((c) => c !== "Sr.No");

    if (tempSelectedColumns.length === colsWithoutSrNo.length) {
      setTempSelectedColumns([]);
    } else {
      setTempSelectedColumns(colsWithoutSrNo);
    }
  };

  const handleColumnToggle = (col: string) => {
    setTempSelectedColumns((prev) =>
      prev.includes(col) ? prev.filter((c) => c !== col) : [...prev, col],
    );
  };

  const handleSaveColumns = () => {
    setSelectedColumns(tempSelectedColumns); // ✅ APPLY
    setIsModalOpen(false);
  };

  const renderTableHeader = () => (
    <tr
      className={
        headerRowClassName ||
        "w-full bg-[#A9B2CF1A] font-medium mx-5 rounded-lg text-sm text-[#1B163B]"
      }
      ref={(e) => {
        refs.current[0] = e;
      }}
    >
      {column.map((item: string, i: number) => {
        if (item !== "Sr.No" && !selectedColumns.includes(item)) return null;

        return (
          <th
            className={
              (headerCellClassName ||
                "h-12 py-3 first:px-6 px-4 max-w-[15rem] align-middle font-medium") +
              " " +
              (item === "Actions" ? "text-center" : "text-left")
            }
            key={i}
          >
            {columnLabels[i]}
          </th>
        );
      })}
    </tr>
  );

  const renderTableData = () =>
    currentItemsArray?.map((row: any, key: number) => {
      const rowWithSrNo =
        srNo === true
          ? [(currentPage - 1) * itemsPerRow.name + 1 + key, ...row]
          : row;
      return (
        <tr
          ref={(e) => {
            refs.current[key] = e;
          }}
          className={
            rowClassName ||
            "bg-[#FFFFFF] overflow-hidden w-full hover:-translate-y-[2px] hover:scale-[1.01] new-shadow transform transition-transform duration-200"
          }
          key={key}
        >
          {rowWithSrNo.map((item: any, i: number) => {
            const colName = column[i];
            if (colName !== "Sr.No" && !selectedColumns.includes(colName))
              return null;
            if (!item) return null;
            return (
              <td className="py-3 pl-4 pr-4 text-left" key={i}>
                <div
                  className={
                    (cellWrapperClassName ||
                      "flex text-xs gap-x-2 items-center max-w-[15rem]") +
                    " " +
                    (colName === "Actions" ? "justify-center" : "justify-between")
                  }
                >
                  <span className="w-full">{item}</span>
                  {copyContent?.length &&
                    !["NA", "N/A"].includes(item) &&
                    copyContent.map((c: any) => {
                      if (c === i + 1)
                        return (
                          <PasteBtn
                            key={c}
                            onClick={() => handleCopyContent(item)}
                            className="cursor-pointer text-[#717171] shrink-0 text-xl"
                          />
                        );
                      return null;
                    })}
                </div>
              </td>
            );
          })}
        </tr>
      );
    });

  return (
    <div
      className={
        "flex w-full flex-col pb-0 rounded-[8px] " +
        (bgColor ?? " bg-[#F6F8FA]") +
        (boxPadding ?? " p-5")
      }
    >
      <div
        className={"w-full text-[#1e1b59] " + (minHeight ?? " min-h-[75vh]")}
      >
        <div className="flex justify-between items-start w-full pr-4">
          <div className="w-full">
            <div className="text-[18px] flex justify-between items-center text-[#1B163B] font-semibold ml-4">
              {heading}
              <div className="flex gap-2">
                {isCustomFilter && (
                  <button
                    onClick={() => {
                      setIsModalOpen(true);
                      setTempSelectedColumns(selectedColumns);
                    }}
                    className="font-normal py-2 text-sm px-6 border text-[#6687FF] border-edviron_black rounded-[4px]"
                  >
                    <FaFilter />
                  </button>
                )}
                {exportBtn && csv_link && (
                  <a download={csv_name} href={csv_link}>
                    <button className="font-normal py-2 text-sm px-6 border text-[#6687FF] border-edviron_black rounded-[4px]">
                      Export
                    </button>
                  </a>
                )}
              </div>
            </div>
            {description && description}
          </div>
        </div>
        {searchBox && (
          <div className="w-full flex justify-between mb-2 items-start px-4 py-2">
            {searchBox}
          </div>
        )}
        {perPage && (
          <RowsPerPageSelect
            setItemsPerRow={setItemsPerRow}
            itemsPerRow={itemsPerRow}
            className=" justify-start"
          />
        )}
        <div className={tableWrapperClassName}>
          <table
            className={
              "table-auto col-span-1 w-full border-separate border-spacing-y-0.5 " +
              tableClassName
            }
          >
            <thead>{renderTableHeader()}</thead>
            {!loading && <tbody>{renderTableData()}</tbody>}
          </table>
          {loading && (
            <div className="col-span-1 space-y-1 mt-2 ">
              {Array(10)
                .fill("")
                .map((_, i) => (
                  <div
                    key={i}
                    className="h-10 bg-slate-400 animate-pulse w-full rounded-lg"
                  ></div>
                ))}
            </div>
          )}
        </div>

        {!loading && footer}
        {!loading && (pagination || perPage) && (
          <div className="my-2 pagination-div flex justify-between">
            {pagination && (
              <div className="w-full flex justify-center">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
            {!loading && perPage && (
              <div className="pb-12">
                <RowsPerPageSelect
                  setItemsPerRow={setItemsPerRow}
                  itemsPerRow={itemsPerRow}
                />
              </div>
            )}
          </div>
        )}
      </div>
      {copyRight && <CopyRight />}

      {/* === Export Modal === */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-[22rem] max-h-[80vh] overflow-y-auto">
            <h2 className="text-lg font-semibold text-[#1B163B] mb-4">
              Select Columns to Export
            </h2>
            <div className="flex items-center mb-3">
              <input
                type="checkbox"
                checked={
                  tempSelectedColumns.length ===
                  column.filter((c) => c !== "Sr.No").length
                }
                onChange={toggleTempSelectAll}
                className="mr-2"
              />
              <label className="text-sm text-[#1B163B]">Select All</label>
            </div>

            {column
              .filter((col) => col !== "Sr.No")
              .map((col, idx) => (
                <div key={idx} className="flex items-center mb-2">
                  <input
                    type="checkbox"
                    checked={tempSelectedColumns.includes(col)}
                    onChange={() => handleColumnToggle(col)}
                    className="mr-2"
                  />
                  <label className="text-sm text-[#1B163B]">{col}</label>
                </div>
              ))}

            <div className="mt-4 flex justify-end gap-3">
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-sm px-4 py-2 border rounded-md text-gray-700"
              >
                Cancel
              </button>
              <button
                className="font-normal py-2 text-sm px-6 border text-white bg-[#1B163B] rounded-md hover:opacity-90"
                onClick={handleSaveColumns}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
